<app-page>
  <app-budget></app-budget>
</app-page>
